import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default, { useContext } from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/header-nav.scss.js';
import { requiredChildrenValidation } from '../../../prop-types-validators/children-validator.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import { HEADER_SUBNAV_ALIGNMENTS } from './types.js';
import { SubMenu } from '../../_atoms/sub-menu/sub-menu.js';
import { HoneyBemContext } from '../../../contexts/honey-bem-context.js';
import { Injecss } from '../../../packages/injecss/injecss.js';

/** @visibleName HeaderSubNavigation */
var HeaderSubNavigation = function (_a) {
  var id = _a.id,
    children = _a.children,
    extraClasses = _a.extraClasses,
    alignment = _a.alignment,
    rest = __rest(_a, ["id", "children", "extraClasses", "alignment"]);
  var parentBem = useContext(HoneyBemContext);
  var bem = parentBem ? HoneyBem.init("".concat(parentBem.block.replace('hcr-', ''), "-subnav"), parentBem.module) : HoneyBem.init('header-nav-subnav', styles);
  return /*#__PURE__*/React__default__default.createElement(HoneyBemContext.Provider, {
    value: bem
  }, /*#__PURE__*/React__default__default.createElement(SubMenu, __assign({
    id: id
  }, rest, {
    className: bem.b(alignment, extraClasses)
  }), children));
};
HeaderSubNavigation.displayName = 'HeaderSubNavigation(SubMenu)';
HeaderSubNavigation.propTypes = {
  id: PropTypes__default.string.isRequired,
  extraClasses: PropTypes__default.string,
  children: requiredChildrenValidation('NavItem'),
  alignment: PropTypes__default.oneOf(HEADER_SUBNAV_ALIGNMENTS)
};
var headerSubNavigation = Injecss(HeaderSubNavigation, styles);

export { HeaderSubNavigation, headerSubNavigation as default };
